// NOTE: This file is included in recording code, so don't add anything that would break IE9.

const importUrlDelims = [
  // @import "..." or @import '...'
  [`@import\\s+"`, `"`], // @import "...";
  [`@import\\s+'`, `'`], // @import '...';
];

export const urlValueDelims = [
  // url(...) and @import url(...)
  [`url\\(\\s*"`, `"\\s*\\)`],
  [`url\\(\\s*'`, `'\\s*\\)`],
  [`url\\(\\s*`, `\\s*\\)`],
];

const cssUrlDelims = importUrlDelims.concat(urlValueDelims);

const notEscape = /(?:[^\\](?:\\\\)*)/.source; // No backslashes, or an even number of them
export const urlPattern = `.*?${notEscape}`; // Ungreedily match any string not ending in a backslash

export const CSS_URL = new RegExp(
  cssUrlDelims.map(([open, close]) => `(${open})(${urlPattern})(${close})`).join('|'),
  'g',
);

export function replaceCssUrls(
  css: string,
  replacer: (open: string, url: string, close: string, index: number) => string,
) {
  return css.replace(CSS_URL, function (_wholeMatch, ...groups) {
    // Each url pattern has 3 groups - the opening delimiter, the url, and the closing delimiter
    const open = groups[0] || groups[3] || groups[6] || groups[9] || groups[12];
    const url = groups[1] || groups[4] || groups[7] || groups[10] || groups[13];
    const close = groups[2] || groups[5] || groups[8] || groups[11] || groups[14];

    const offset = groups[15]; // Not a match group, but the last parameter of the `replace` callback

    return replacer(open, url, close, offset);
  });
}

export const SIMPLE_CSS_URL = /url\(["']?(.+?)["']?\)/g;
export const QUOTES = /"|'/g;
export const HOVER = /:hover/g;
export const FOCUS = /:focus/g;
export const FOCUS_WITHIN = /:focus-within/g;
export const MEDIA_QUERY = /(@media.*?{)/g;
export const DOMAIN = /^[a-zA-Z0-9][a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;
// Note: This does not verify that the domain part starts with a letter and ends with a letter or number.
export const DOMAIN_PART = /^[a-zA-Z0-9-:]{0,63}$/;
export const LETTER_OR_NUMBER = /[a-zA-Z0-9]/;
export const IPv4_PART = /^[0-9]{1,3}$/; // TODO(pratik): this accepts numbers like 500. fix.
export const IPv6_PART = /^[0-9a-f]{0,4}$/;
export const PLAYBACK_URL_PARAMS = /.*\?Base=(.*)&Url=(.*)/;
export const EMAIL =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const IMAGE_FILENAME = /\.(jpe?g|png|svg|gif|bmp)$/;
export const WATCH_RULE_COMMENT = /^\s*\/\//;
export const DATA_URI = /^data:([^;,]*)[;,]/i;

// These mirror the content type blocklist and allowlist in resources_gae.go;
// see that code for the details. Keep them in sync when you make changes.
export const SKETCHY_CONTENT_TYPES = /(application|script|text\/js|text\/html)/i;
export const ALLOWLISTED_CONTENT_TYPES =
  /(^application\/octet-stream)|(^font\/)|(^application\/[a-z_.-]*font)/i;

// README adapted from this SO article
//   https://stackoverflow.com/questions/3115150/how-to-escape-regular-expression-special-characters-using-javascript/9310752#9310752
//   with some inspiration from lodash: https://github.com/lodash/lodash/blob/ddfd9b11a0126db2302cb70ec9973b66baec0975/lodash.js#L14273-L14277
const regExpChars = /[-\\^$*+?.()|[\]{}]/g;
const regExpTest = new RegExp(regExpChars.source);

export const escapeRegex = (str: string): string => {
  if (regExpTest.test(str)) {
    return str.replace(regExpChars, '\\$&');
  }
  return str;
};
